import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import CivilStatusForm from './form';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import { AccordionCivilStatus } from 'shell/view-models/accordion-civil-status';
import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';

interface CivilStatusProps {
  disabled?: boolean;
}

const CivilStatusComponent = ({ disabled }: CivilStatusProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<CohabitationDetailForm>();

  const onFieldCivilStatusChange = useEventCallback(
    (key: keyof AccordionCivilStatus, value: AccordionCivilStatus[keyof AccordionCivilStatus]) => {
      formContext.setFieldValue('civilStatus', {
        ...formContext.values.civilStatus,
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-civil-status-content"
        id="panel-person-civil-status-header"
        expandIcon={<ExpandMore />}
      >
        <AccordionTitle>Stato Civile</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <CivilStatusForm
          values={formContext.values.civilStatus}
          disabled={disabled}
          onChange={onFieldCivilStatusChange}
          errors={formContext.errors.civilStatus as FormikErrors<AccordionCivilStatus>}
          touched={formContext.touched.civilStatus as FormikTouched<AccordionCivilStatus>}
        />
      </AccordionDetails>
    </Accordion>
  );
};

CivilStatusComponent.displayName = 'Accordion civil status component';

const CivilStatus = memo(CivilStatusComponent);

export default CivilStatus;
